import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

const slice = (state: RootState) => state.networkState;

// Section list
export const networkSectionsQuery = createSelector(slice, (state) => state.networkSections);
export const loadingNetworkSectionsQuery = createSelector(slice, (state) => state.resetNetworkSectionsOngoing);

// Selection
export const selectedNetworkSectionsQuery = createSelector(slice, (state) =>
    state.networkSections.filter((networkSection) => state.selectedNetworkSectionIds.includes(networkSection.id)),
);
export const selectedNetworkSectionIdsQuery = (state) =>
    selectedNetworkSectionsQuery(state).map((networkSection) => networkSection.id);

// Sorting
export const networkSectionsSortQuery = createSelector(slice, (state) => state.sort);

// Filtering
export const networkSectionsFilterQuery = createSelector(slice, (state) => state.filter);

// Pagination
export const networkSectionsPaginationQuery = createSelector(slice, (state) => state.pagination);

// Column visibility
export const networkSectionsColumnVisibilityQuery = createSelector(slice, (state) => state.columnVisibility);
